import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { CELL } from '../lib/constants'
import { fill } from '../dict'
import {
  ChannelName,
  Header,
  HeaderRight,
  IconBtn,
  InlineSelect,
  RecordDot,
  Speed,
} from '../styles/cell'

function formatSpeed(kbps) {
  if (kbps === null || kbps === undefined) return '—'
  return `${Math.round(kbps)}`
}

/** ปุ่มบนหัวกรอบไม่ควรไปสั่ง "เลือกกรอบ" ที่ผูกไว้กับตัว Cell ด้วย */
const isolate = handler => event => {
  event.stopPropagation()
  handler()
}

export function cameraLabel(cam, txt) {
  if (cam.name && !/^ch\d+$/i.test(cam.name)) return cam.name
  return fill(txt.cameraFallback, { n: String(cam.camera).padStart(2, '0') })
}

export default function CellHeader({
  label,
  speed,
  state,
  muted,
  cameras,
  camera,
  txt,
  onToggleMute,
  onCameraChange,
  onRetry,
  onClose,
}) {
  const playing = state === CELL.PLAYING
  // KB/s เป็น 0 ทั้งที่สถานะบอกว่าเล่นอยู่ = มีอะไรผิดปกติ
  const stale = state === CELL.STALLED || (playing && speed === 0)
  const showCameras = cameras.length > 1 && !!onCameraChange

  return (
    <Header>
      <ChannelName>{label}</ChannelName>

      {showCameras && (
        <Tooltip title={txt.camera}>
          <InlineSelect
            value={camera === null ? '' : camera}
            onClick={e => e.stopPropagation()}
            onChange={e => onCameraChange(Number(e.target.value))}
          >
            {cameras.map(cam => (
              <option key={cam.camera} value={cam.camera}>
                {cameraLabel(cam, txt)}
              </option>
            ))}
          </InlineSelect>
        </Tooltip>
      )}

      <Speed stale={stale}>
        {formatSpeed(speed)}
        {txt.speedUnit}
      </Speed>

      <HeaderRight>
        {playing && <RecordDot />}

        <Tooltip title={muted ? txt.unmute : txt.mute}>
          <IconBtn type="button" onClick={isolate(onToggleMute)}>
            {muted ? '🔇' : '🔊'}
          </IconBtn>
        </Tooltip>

        <Tooltip title={txt.retry}>
          <IconBtn type="button" onClick={isolate(onRetry)}>
            ↻
          </IconBtn>
        </Tooltip>

        <Tooltip title={txt.close}>
          <IconBtn type="button" danger onClick={isolate(onClose)}>
            ✕
          </IconBtn>
        </Tooltip>
      </HeaderRight>
    </Header>
  )
}

CellHeader.propTypes = {
  label: PropTypes.string.isRequired,
  speed: PropTypes.number,
  state: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  /** [{ camera, name }] จาก discovery */
  cameras: PropTypes.array,
  camera: PropTypes.number,
  txt: PropTypes.object.isRequired,
  onToggleMute: PropTypes.func.isRequired,
  onCameraChange: PropTypes.func,
  onRetry: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}
